export default __webpack_public_path__ + "static/media/Palette.c56fc420.svg";